import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import { setHighlight } from "../../../abstract/redux/slice/overlaySlice";
import { getRoot } from "../../../abstract/redux/slice/structureSlice";
import IconBxsDownArrow from "../../../themes/icons/IconBxsDownArrow";
import IconBxsRightArrow from "../../../themes/icons/IconBxsRightArrow";
import IconDash from "../../../themes/icons/IconDash";
import DefaultTooltip, * as vendorTooltip from "../../ui/tooltips/DefaultTooltip";
import styles from "./AsideElementGlobal.module.scss";

function AsideElementGlobal({ showGlobals, setShowGlobals }) {
  const _root = useSelector(getRoot);

  const [_showNavigation, _setShowNavigation] = useState(false);

  const handleOnClick = () => {
    _setShowNavigation((e) => !e);
  };

  if (!setShowGlobals) {
    return null;
  }

  const _parametersGlobal = nodeUtils.getParameters(_root);

  return (
    <div className={styles["navigation"]}>
      <div className={styles["navigation__header"]} role="button" onClick={handleOnClick}>
        <span className={styles["navigation__icon"]}>
          {_showNavigation ? <IconBxsDownArrow /> : <IconBxsRightArrow />}
        </span>
        &nbsp;&nbsp;
        <span className={styles["navigation__header"]}>Global parameters</span>
      </div>

      <div
        className={`${styles[`navigation__body__content`]} ${
          !_showNavigation || !_parametersGlobal.length ? styles["styles--collapse"] : ""
        }`}>
        <div className={styles["navigation__body__list"]}>
          {_parametersGlobal.map((e) => (
            <ContainerParameters
              key={nodeUtils.getID(e)}
              node={e}
              isSectionVisible={showGlobals}
              setSectionVisible={setShowGlobals}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

const ContainerParameters = ({ isSectionVisible, setSectionVisible, node }) => {
  const dispatch = useDispatch();
  const [_showElement, _setShowElement] = useState(false);
  const _id = nodeUtils.getID(node);
  const _uuid = nodeUtils.getUUID(node);
  const _hasParameters = nodeUtils.hasParameters(node);

  const handleOnClick = () => {
    setSectionVisible(true);
    dispatch(setHighlight(_id));
  };

  const handleOnClickItem = () => {
    _setShowElement((e) => !e);
  };

  return (
    <>
      <div onClick={handleOnClick}>
        <div
          className={styles["navigation__body__list__item"]}
          data-tooltip-id={_uuid}
          data-tooltip-delay-show={vendorTooltip.getTimeSlow()}
          onClick={handleOnClickItem}>
          <span className={styles["navigation__body__icon"]}>
            {_hasParameters ? (
              _showElement ? (
                <IconBxsDownArrow />
              ) : (
                <IconBxsRightArrow />
              )
            ) : (
              <IconDash />
            )}
          </span>
          &nbsp;
          <div className={styles["text-box"]}>{nodeUtils.getName(node)}</div>
        </div>
      </div>

      <DefaultTooltip handle={_uuid}>
        <TooltipParameter node={node} />
      </DefaultTooltip>

      {_hasParameters && _showElement && (
        <ul className={styles["navigation__body__list"]}>
          {nodeUtils.getParameters(node).map((e) => (
            <ContainerParameters
              key={nodeUtils.getID(e)}
              node={e}
              isSectionVisible={isSectionVisible}
              setSectionVisible={setSectionVisible}
            />
          ))}
        </ul>
      )}
    </>
  );
};

const TooltipParameter = ({ node }) => {
  const _target = nodeUtils.getIdTarget(node);
  const _output = nodeUtils.getValueDefault(node);

  return (
    <>
      <div>{nodeUtils.getName(node)}</div>
      {_target && (
        <>
          <div className={styles["tooltip__parameter"]}>Linked parameter name:</div>
          <div>{_target}</div>
        </>
      )}
      {_output && (
        <>
          <div className={styles["tooltip__parameter"]}>Output value:</div>
          <div>{`'${_output}'`}</div>
        </>
      )}
      {!_target && !_output && (
        <>
          <div className={styles["tooltip__parameter"]}>Parameter choices:</div>
          <div>
            {nodeUtils.getChoices(node).map((e) => (
              <TooltipChoice key={nodeUtils.getID(e)} node={e} />
            ))}
          </div>
        </>
      )}
    </>
  );
};

const TooltipChoice = ({ node }) => {
  return (
    <>
      <div className={styles["tooltip__choice__item"]}>{`- ${nodeUtils.getName(node)}`}</div>

      {nodeUtils.hasChoices(node) && (
        <ul className={styles["tooltip__choice"]}>
          {nodeUtils.getChoices(node).map((e) => (
            <TooltipChoice key={nodeUtils.getID(e)} node={e} />
          ))}
        </ul>
      )}
    </>
  );
};

export default AsideElementGlobal;
